import { createGlobalStyle } from 'antd-style';

const DocumentStyles = createGlobalStyle(({ theme }) => ({
  '*': {
    boxSizing: 'border-box',
  },
  html: {
    fontSize: theme.fontSize,
  },
  p: {
    margin: 0,
  },
  body: {
    fontFamily: theme.fontFamily,
    lineHeight: theme.lineHeight,
    color: theme.colorText,
    margin: 0,
    WebkitFontSmoothing: 'antialiased',
    MozOsxFontSmoothing: 'grayscale',
  },
  'button:focus': {
    outline: 'none',
  },
  'input, select, textarea': {
    '&:-webkit-autofill': {
      // Colors cannot be overriden, but we can make them animate so slow that they will never take effect
      '&, &:hover, &:focus': {
        transition:
          'background-color 9999s ease-in-out 0s, color 9999s ease-in-out 0s',
      },
    },
  },
  // Reset of antd's selection style
  '::selection': {
    backgroundColor: '#2f7fdf !important',
    color: `${theme.colorWhite} !important`,
  },
}));

export default DocumentStyles;
